<template>
  <!-- 拍照上传 返回拍照后的图片地址  by lbj-->
  <div>
    <el-dialog
      class="camera"
      v-dialogDrag
      lock-scroll
      append-to-body
      :title="'拍照上传'"
      :show-close="false"
      :visible.sync="show"
      :close-on-click-modal="false"
    >
      <!-- 外部弹窗：顶部 -->
      <div slot="title" class="reports_title_box">
        <div class="reports_title">拍照上传</div>
        <div class="reports_title_btn">
          <i class="el-icon-close" v-preventReClick @click="closeDialog" />
        </div>
      </div>

      <!-- 外部弹窗内容部分 -->
      <div class="content">
        <div class="cameraFlex">
          <div class="cameraFlexSon">
            <div class="title">
              <div>
                <label>摄像头</label>
                <el-select clearable  
                v-model="cameraTarget" :placeholder="'请选择摄像头'">
                  <el-option
                    v-for="(choice, i) in camreass"
                    :key="i"
                    :label="choice.label"
                    :value="choice"
                  />
                </el-select>
              </div>
            </div>
            <video
              id="videoCamera"
              class="img_bg_camera bg1"
              :width="videoWidth"
              :height="videoHeight"
              autoplay
            />
            <canvas
              id="canvasCamera"
              style="display: none"
              :width="videoWidth2"
              :height="videoHeight2"
            />
            <el-button
              type="primary"
              size="mini"
              :disabled="!openCamera"
              :loading="!openCamera"
              :circle="false"
              v-preventReClick
              @click="setImage()"
              :style="{ width: videoWidth + 'px', marginTop: '5px' }"
              >拍照</el-button
            >
          </div>
          <div class="cameraFlexSon">
            <div class="title">
              <div class="titleson">
                照片预览
                <div>
                  <svg-icon
                    icon-class="slectJobNumflesh"
                    style="transform: rotateY(180deg)"
                    @click="l90()"
                  />
                  <svg-icon icon-class="slectJobNumflesh" @click="r90()" />
                </div>
              </div>
            </div>
            <div class="img_bg_camera bg2">
              <div class="img_bg_box">
                <!-- <img :src="imgSrc" alt class="tx_img" /> -->
                <vueCropper
                  ref="cropper"
                  :img="imgSrc"
                  :outputSize="option.size"
                  :outputType="option.outputType"
                  :info="true"
                  :full="option.full"
                  :canMove="option.canMove"
                  :canMoveBox="option.canMoveBox"
                  :original="option.original"
                  :autoCrop="option.autoCrop"
                  :fixed="option.fixed"
                  :fixedNumber="option.fixedNumber"
                  :centerBox="option.centerBox"
                  :infoTrue="option.infoTrue"
                  :fixedBox="option.fixedBox"
                ></vueCropper>
              </div>
            </div>
            <div class="filename">
              <label>重命名</label>
              <el-input v-model="filename" placeholder></el-input>
            </div>
            <el-button
              type="primary"
              size="mini"
              :disabled="!haspic"
              :loading="!haspic"
              :circle="false"
              v-preventReClick
              @click="sendpic()"
              :style="{ width: videoWidth + 'px', marginTop: '5px' }"
              >保存</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { drag, dataURLtoFile } from '@/assets/js/pubMethods'
// 此组件有漏洞，如果需要放出来，可能会导致弹出框异常，内存溢出！如果需要，请在main.js引用
// import { VueCropper } from "vue-cropper";
import { parseTime } from '@/utils'
export default {
  directives: {
    // 指令
    dialogDrag: {
      bind: drag // 实现拖拽
    }
  },
  // components: {
  //   VueCropper,
  // },
  data() {
    return {
      videoWidth: 380,
      videoHeight: 285,
      videoWidth2: 1944,
      videoHeight2: 1458,
      imgSrc: '',
      thisCancas: null,
      thisContext: null,
      thisVideo: null,
      show: false,
      openCamera: false,
      haspic: false,
      cameraTarget: null,
      camreass: [],
      filename: '', //文件重命名
      option: {
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        // autoCropWidth: 300, // 默认生成截图框宽度
        // autoCropHeight: 200, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      }
      // this.videoWidth2 = 2592
      // this.videoHeight2 = 1944
    }
  },
  watch: {
    show: {
      handler: function(n) {
        if (n) {
          const ww = window.innerWidth
          const ws = ww <= 1024 ? 340 : ww <= 1440 ? 420 : 540
          this.videoWidth = ws
          this.videoHeight = ws
          this.openCamera = false
          this.haspic = false
          this.imgSrc = ''
          this.cameraTarget = null
          this.camreass = []
          setTimeout(() => {
            this.getCompetence()
          }, 100)
        } else {
        }
      },
      deep: true //对象内部的属性监听，也叫深度监听
    },
    cameraTarget(n, o) {
      if (n !== null && n) {
        //console.log(n, 'cameraTarget')
        if (this.thisVideo !== null && this.openCamera) {
          // console.log(this.thisVideo.srcObject.getTracks(),'this.thisVideo.srcObject.getTracks()2222');
          this.thisVideo.srcObject.getTracks()[0].stop()
          this.openCameraId()
        }
      }
    }
  },
  methods: {
    closeDialog() {
      this.show = false
      this.stopNavigator()
    },
    // 调用权限（打开摄像头功能）
    getCompetence() {
      var _this = this
      this.thisCancas = document.getElementById('canvasCamera')
      this.thisContext = _this.thisCancas.getContext('2d')
      this.thisVideo = document.getElementById('videoCamera')
      // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {}
      }
      // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
      // 使用getUserMedia，因为它会覆盖现有的属性。
      // 这里，如果缺少getUserMedia属性，就添加它。
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function(constraints) {
          // 首先获取现存的getUserMedia(如果存在)
          var getUserMedia =
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.getUserMedia
          // 有些浏览器不支持，会返回错误信息
          // 保持接口一致
          if (!getUserMedia) {
            return Promise.reject(
              new Error('getUserMedia is not implemented in this browser')
            )
          }
          // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
          return new Promise(function(resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject)
          })
        }
      }
      navigator.mediaDevices.getUserMedia({ audio: true, video: true })
      navigator.mediaDevices.enumerateDevices().then(devices => {
        console.log(devices)
        devices.forEach(e => {
          if (e.kind === 'videoinput' && e.deviceId) {
            this.camreass.push(e)
          }
        })
        this.cameraTarget = this.camreass[0]
        this.openCameraId()
      })
    },
    // 打开指定摄像头
    openCameraId() {
      var _this = this
      var constraints = {
        audio: false,
        video: {
          facingMode: 'environment',
          deviceId: this.cameraTarget.deviceId,
          width: { ideal: this.videoWidth2 },
          height: { ideal: this.videoHeight2 },
          // width:_this.videoWidth,
          // height: _this.videoHeight,
          transform: 'scaleX(-1)'
        }
      }
      var promise = navigator.mediaDevices
        .getUserMedia(constraints)
        .then(stream => {
          // console.log(stream, this.camreass, '2222')
          // 旧的浏览器可能没有srcObject
          if ('srcObject' in this.thisVideo) {
            _this.thisVideo.srcObject = stream
          } else {
            // 避免在新的浏览器中使用它，因为它正在被弃用。
            _this.thisVideo.src = window.URL.createObjectURL(stream)
          }
          _this.thisVideo.onloadedmetadata = function(e) {
            _this.thisVideo.play()
            _this.openCamera = true
          }
        })
        .catch(err => {
          // console.log(err)
          _this.$message.error(
            '调用摄像头失败，请检查摄像头是否接入以及授权！' + err
          )
        })
      //  console.log(promise,'11111111111');
    },
    //  绘制图片（拍照功能）
    setImage() {
      //-CWidth*((ratio-1)/2),-CHeight*((ratio-1)/2), CWidth*ratio, CHeight*ratio
      var _this = this
      console.log(_this.thisVideo, _this.videoWidth, _this.videoHeight, 1111)

      // 点击，canvas画图
      _this.thisContext.drawImage(
        _this.thisVideo,
        0,
        0,
        // 2592,
        // 1944
        _this.videoWidth2,
        _this.videoHeight2
      )
      // 获取图片base64链接
      var image = _this.thisCancas.toDataURL('image/jpeg')
      _this.imgSrc = image
      this.haspic = true
      //_this.$emit('refreshDataList', _this.imgSrc)
    },
    // 关闭摄像头
    stopNavigator() {
      // console.log(this.thisVideo.srcObject.getTracks(),'this.thisVideo.srcObject.getTracks()');

      if (this.thisVideo !== null && this.openCamera) {
        // alert(this.thisVideo.srcObject.getTracks().length)
        this.thisVideo.srcObject.getTracks()[0].stop()
        this.thisVideo = null
      }
    },
    //返回图片地址
    sendpic() {
      this.$refs.cropper.getCropData(data => {
        // do something
        // console.log(data)
        var filename = dataURLtoFile(
          // this.imgSrc,
          data,
          (this.filename
            ? this.filename
            : parseTime(new Date(), '{y}{m}{d}{h}{i}{s}') + '摄像头拍照') +
            '.jpg'
        )
        this.$emit('refreshDataList', filename)
        this.closeDialog()
      })
    },
    // 左90°
    l90() {
      this.$refs.cropper.rotateLeft()
    },
    // 右90°
    r90() {
      this.$refs.cropper.rotateRight()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
// 外部弹窗
.el-dialog__wrapper.camera {
  /deep/.el-dialog {
    @include wh(1200px, 700px);
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
    margin: 0 !important;
    @include center;
    // 表头
    .el-dialog__header {
      height: 46px;
      padding: 0;
      /* color: #fff; */
      .reports_title_box {
        padding: 0 20px;
        /* background: $active-color; */
        display: flex;
        justify-content: space-between;
        align-items: center;
        @include font(16px, 46px);
        .reports_title {
          font-weight: bold;
          display: flex;
          align-items: center;
          // img {
          //   @include wh(24px, 24px);
          //   margin-right: 6px;
          // }
          svg {
            font-size: 20px;
            color: $active-color;
          }
        }
        .reports_title_btn {
          display: flex;
          align-items: center;
          .help,
          .el-icon-close {
            font-weight: bold;
            padding: 0 5px;
            @include font(14px, 46px);
            cursor: pointer;
          }
        }
      }
    }
    // 主体
    .el-dialog__body {
      padding: 0;
      flex: 1;
      overflow: hidden;
      .content {
        padding: 0 10px;
        //内容自定义部分 begin
        .cameraFlex {
          display: flex;
          justify-content: space-between;
          .cameraFlexSon {
            flex: 1;
            margin: 5px;
            @include wh(540px, 540px);
            // background: #000
            .title {
              font-size: 16px;
              height: 30px;
              line-height: 30px;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              margin-bottom: 10px;
              span {
                font-size: 14px;
                height: 30px;
                line-height: 30px;
                display: inline-block;
                vertical-align: top;
              }
              .el-select {
                margin-left: 10px;
                .el-input__inner {
                  border-color: rgba(44, 141, 238, 1);
                }
              }
              .titleson {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
              }
            }
            .title::before {
              content: '';
              display: inline-block;
              width: 7px;
              height: 30px;
              margin-right: 10px;
              background: #1890ff;
            }
          }
          .img_bg_camera {
            border: 1px solid #dfdfdf;
            padding: 10px;

            .img_bg_box {
              @include wh(520px, 473px);
              display: flex;
              justify-content: content;
              align-items: center;
              .tx_img {
                @include wh(460px, 460px);
                // max-height: 460px;
                // width: 460px;
                margin: 5px auto;
                display: block;
                // border: 1px dashed #dfdfdf;
                // background: center center no-repeat;
                // background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAB1UlEQVRoQ+2av2obQRDG59s7xZCQgByI8g5JlyZlILiIwY17gUBRI1lF3uDeIAH9aU6CGHdqXBjUuXDlxmXeQSECCWJskNHuF05cmoua4/aCBXP13bc73/xmuF0GUtJDEr1e73ki3+12bwGwjKVQhmgURaZWq30A8DnRt9bG8/n8Kooi53u9UgIYDofVIAi+i8hRuuELa22j3W4vdyKAwWDwOgiCcwDvkw2TvLbWHnc6nZ8aQMaBUhDSDOTgTDOwzSxFSBHK4YAiVNAs7UKKkCJU0AFFqKCB2oUeBULJAXw8HleNMUHBjG4+X6/Xr0ieisi79ER2Y4xphGH4y4e+c842m81lclGAyWQSLBaLAwAnJJ/5WADAE5JvAbxIA/gN4AfJB0/6dwC+tVqtS/T7/ZeVSuVMRD75EN+mQVIAv+UGYGqMqWM0Gu07585IHu5SACSnYRjWkfAfx/FHEfkiIk99BEFyj+SbLEIAvCDknLs3xnzdIJQy6rWIV6tVzRiT3AuVX8Q+HM9q6JEyh6t+W0O6sGZAM5DDgUfxL1Rwv/98rjWQw1HtQloDOXDZ9qoipAgpQgUdUIQKGqhdaJuBOz9qkB32ABDPZrPdGfb4e1HwP8Zt/gACxlsXQlpj0gAAAABJRU5ErkJggg==');
              }
            }
          }
          .bg1 {
            background: url('~@/assets/img/carbg (1).png') center center
              no-repeat;
            background-size: 60%;
          }
          .bg2 {
            background: url('~@/assets/img/carbg (2).png') center center
              no-repeat;
            background-size: 60%;
          }
          .filename {
            font-size: 14px;
            height: 30px;
            line-height: 30px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin: 10px 0;
            label {
              width: 70px;
            }
            .el-input {
              .el-input__inner {
                border-color: rgba(44, 141, 238, 1);
              }
            }
          }
        }
        //内容自定义部分 end
      }
    }
    // 尾部
    .el-dialog__footer {
      height: 70px;
      padding: 0;
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
      .dialog_footer {
        padding: 0 30px;
        @include wh(100%, 70px);
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .footer_tools {
          padding-left: 215px;
        }
      }
    }
  }
}
// // 媒体查询 @1440px
// @media screen and (max-width: 1440px) {
//   .el-dialog__wrapper.camera {
//     /deep/.el-dialog {
//       @include wh(1200px, 600px);
//       .el-dialog__header {
//         height: 36px;
//         .reports_title_box {
//           line-height: 36px;
//           .reports_title {
//             font-weight: bold;
//             @include font(16px, 36px);
//             .svg-icon {
//               font-size: 16px;
//             }
//           }
//           .reports_title_btn {
//             .el-icon-close {
//               font-weight: bold;
//               line-height: 36px;
//             }
//           }
//         }
//       }
//       // 主体
//       .el-dialog__body {
//         .content {
//           .cameraFlex {
//             .cameraFlexSon {
//               @include wh(420px, 420px);
//             }
//             .img_bg_camera {
//               .img_bg_box {
//                 @include wh(400px, 354px);
//                 .tx_img {
//                   @include wh(350px, 350px);
//                 }
//               }
//             }
//           }
//           //内容自定义部分 end
//         }
//       }
//       .el-dialog__footer {
//         height: 56px;
//         .dialog_footer {
//           height: 56px;
//         }
//       }
//     }
//   }
// }

// // 媒体查询 @1024px
// @media screen and (max-width: 1024px) {
//   .el-dialog__wrapper.camera {
//     /deep/.el-dialog {
//       @include wh(700px, 550px);
//       // 主体
//       .el-dialog__body {
//         .content {
//           //内容自定义部分 begin
//           .cameraFlex {
//             .cameraFlexSon {
//               @include wh(340px, 340px);
//             }
//             .img_bg_camera {
//               .img_bg_box {
//                 @include wh(320px, 273px);
//                 .tx_img {
//                   @include wh(260px, 260px);
//                 }
//               }
//             }
//           }
//           //内容自定义部分 end
//         }
//       }
//     }
//   }
// }
</style>
